import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
const TheBanner = () => {
  const [nav, setNav] = useState(false);
  const navigate = useNavigate();
  const handleNav = () => {
    setNav(true);
  };

  const handleCloseNav = () => {
    setNav(false);
  };
  const handleScroll = (node) => {
    node.scrollIntoView({ behavior: "smooth" });
  };

  const location = useLocation();

  return (
    <>
      {location.pathname !== "/thongtinnguoidung" && (
        <section className="banner">
          <img className="img-full" src="assets/img/KV.jpeg" alt="line-bt" />
          <div className="group-action container">
            <div className="group-btn-inline">
              {/* <button
                  type="button"
                  className="btn btn-warning btn-block"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <a href="#guide">HƯỚNG DẪN</a>
                </button> */}
              {location.pathname == "/" && (
                <a href="#joinNow">
                  <img
                    className="img-full"
                    src="assets/img/text-scroll.png"
                    alt="line-bt"
                  />
                </a>
              )}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default TheBanner;
